import { DeveloperProfileConstants } from "sj-ui-toolkit/src/constants/developerProfile";

export const formatDeveloperProfile = user => {
  return {
    firstName: user?.name?.givenName || "",
    lastName: user?.name?.familyName || "",
    company: user?.attributes?.company || "",
    title: user?.attributes?.title || "",
    country: user?.attributes?.country || "",
    email: user?.email || "",
    role: user?.attributes?.jobRole || "",
    function: user?.developerProfile?.jobFunction || "",
    experience: user?.developerProfile?.experience || "",
    expertise: user?.developerProfile?.expertise || "",
    language: user?.developerProfile?.language || "",
    tooling: user?.developerProfile?.topics || [],
  };
};

const normalizeTopics = tooling => {
  if (Array.isArray(tooling)) return tooling;
  if (!tooling) return [];

  return String(tooling)
    .split(",")
    .map(t => t.trim())
    .filter(Boolean);
};

const buildTopicsPayload = (tooling, toolingOther) => {
  const selected = normalizeTopics(tooling);

  if (selected.includes("other") && toolingOther) {
    return [...selected, toolingOther];
  }

  return selected;
};

export const buildUserProfilePayload = formData => {
  const language = formData.language === "other" ? formData.languageOther : formData.language;

  return {
    email: formData.email,
    name: {
      givenName: formData.firstName,
      familyName: formData.lastName,
    },
    attributes: {
      jobRole: formData.role,
      title: formData.title,
      country: formData.country,
      company: formData.company,
    },
    developerProfile: {
      experience: formData.experience,
      expertise: formData.expertise,
      jobFunction: formData.function,
      language: language,
      topics: buildTopicsPayload(formData.tooling, formData.toolingOther),
    },
  };
};

/**
 * Normalizes the topics array returned from API into separate UI values.
 *
 * @param {string[]} topics - Array of values from API (may include known options, and "other" flag, and custom user entered value).
 * @returns {{ tooling: string[], toolingOther: string }}
 * tooling: Valid MultiSelect values (plus *other* when selected)
 * toolingOther: Custom user entered value (if any)
 */
export const normalizeToolingWithOther = (topics = []) => {
  const validOptions = DeveloperProfileConstants.OPTIONS.architectureTools.map(opt => opt.value);

  const knownValues = [];
  let toolingOther = "";
  let hasOther = false;

  topics.forEach(item => {
    if (item === "other") {
      hasOther = true;
    } else if (validOptions.includes(item)) {
      knownValues.push(item);
    } else if (!toolingOther) {
      toolingOther = item;
    }
  });

  const tooling = hasOther ? [...knownValues, "other"] : knownValues;

  return {
    tooling,
    toolingOther,
  };
};
